export class Tenant {
  public id: number;
  public name: string;
  public code: string;
  public isEnabled: boolean = true;
}
